<template>
  <div id="records">
    <a-spin :spinning="spinLoading">
      <div class="search-form ant-round-form">
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_receipt_102') }}: </span>
          <!-- date picker -->
          <a-range-picker
            v-model:value="dateOpts"
            format="YYYY/MM/DD"
            @change="handleDateChange"
          />
          <span v-if="dateRangeError" class="date-range-error">
            {{ $t('date_range_limit_month') }}
          </span>
        </div>
      </div>
      <div class="op-part">
        <div class="edit-btn">
          <a-button
            shape="round"
            class="btn-success"
            style="margin-right: auto"
            :loading="exporting"
            @click="exportAlert()"
          >
            <template #icon><bars-outlined /></template>
            {{ exporting ? $t('pages_receipt_099') : $t('pages_receipt_098') }}
          </a-button>
        </div>
      </div>
      <div class="table-part">
        <a-table
          :scroll="{ x: 1200 }"
          :loading="loading"
          :pagination="false"
          :custom-header-row="() => { return {class: 'my-table-tr'}}"
          :columns="columns"
          :data-source="records"
        >
          <!-- <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'edit' && !record.preDisputeDecision">
              <a-button
                shape="round"
                size="small"
                class="btn-primary-empty-0"
                @click="showDecision(record)"
              >{{ $t('pages_receipt_074') }}</a-button>
            </template>
          </template> -->
        </a-table>
        <table-page
          :total="total"
          :page-opts="searchQuery"
          @update-page="updatePage"
        />
      </div>
    </a-spin>
  </div>
</template>

<script>
import TablePage from '@/components/table-page'
import { reactive, toRefs, ref } from 'vue'
import { _order } from '@/api'
import { parseMoney } from '@/util'
import i18n from '@/locale'
import moment from 'moment'
import { message } from 'ant-design-vue'
export default {
  name: 'RdrRecords',
  components: {
    'table-page': TablePage
  },
  props: {

  },
  setup (props) {
    const state = reactive({
      loading: true,
      decisionVisible: false,
      spinLoading: false,
      total: 0,
      searchQuery: {
        pageNum: 1,
        pageSize: 10,
        merchantOrderNo: null
      },
      records: [],
      columns: [
        { key: 'eventId', dataIndex: 'eventId', title: i18n.global.t('pages_receipt_055'), width: 180, ellipsis: true },
        { key: 'eventDateUtc', dataIndex: 'eventDateUtc', title: i18n.global.t('pages_receipt_056'), width: 180, ellipsis: true },
        { key: 'eventCorrelationId', dataIndex: 'eventCorrelationId', title: i18n.global.t('pages_receipt_057'), width: 180, ellipsis: true },
        { key: 'transactionDate', dataIndex: 'transactionDate', title: i18n.global.t('pages_receipt_068'), width: 180, ellipsis: true },
        { key: 'transactionAmount', dataIndex: 'transactionAmount', title: i18n.global.t('pages_receipt_070'), width: 150 },
        // { key: 'transactionCurrency', dataIndex: 'transactionCurrency', title: i18n.global.t('pages_receipt_071'), width: 100 },
        { key: 'creditCardBin', dataIndex: 'creditCardBin', title: i18n.global.t('pages_receipt_067'), width: 180 },
        { key: 'arn', dataIndex: 'arn', title: i18n.global.t('pages_receipt_062'), width: 180 },
        { key: 'processorName', dataIndex: 'processorName', title: i18n.global.t('pages_receipt_087'), width: 100, ellipsis: true },
        { key: 'chargebackReasonCode', dataIndex: 'chargebackReasonCode', title: i18n.global.t('pages_receipt_069'), width: 100 },
        { key: 'reportedAmount', dataIndex: 'reportedAmount', title: i18n.global.t('pages_receipt_088'), width: 150 },
        // { key: 'reportedCurrency', dataIndex: 'reportedCurrency', title: i18n.global.t('pages_receipt_089'), width: 100 },
        { key: 'status', dataIndex: 'status', title: i18n.global.t('pages_receipt_090'), width: 100 },
        { key: 'rdrDate', dataIndex: 'rdrDate', title: i18n.global.t('pages_receipt_091'), width: 180, ellipsis: true },
        { key: 'fee', dataIndex: 'fee', title: i18n.global.t('pages_receipt_072'), width: 150 }
        // { key: 'feeCurrency', dataIndex: 'feeCurrency', title: i18n.global.t('pages_receipt_073'), width: 100 }
      ]
    })

    const dateOpts = ref(null)
    const dateRangeError = ref(false)

    const handleDateChange = (dates) => {
      if (dates && dates.length === 2 && dates[0] && dates[1]) {
        const startDate = dates[0]
        const endDate = dates[1]
        const maxEndDate = moment(startDate).add(1, 'month')

        // 检查是否超过一个月
        if (endDate.isAfter(maxEndDate)) {
          dateRangeError.value = true
          // 自动调整结束日期
          dateOpts.value = [startDate, maxEndDate]
        } else {
          dateRangeError.value = false
        }
      }
    }

    const exportAlert = async () => {
      if (dateRangeError.value || !dateOpts.value || dateOpts.value.length !== 2) {
        // show error message
        message.error(i18n.global.t('pages_nuvei_001'))
        return
      }

      state.exporting = true
      const query = {
        eventStartDate: new Date(dateOpts.value[0]).getTime(),
        eventEndDate: new Date(dateOpts.value[1]).getTime()
      }
      await _order.exportRdrAlert(query)
      state.exporting = false
    }

    const updatePage = (page, pageSize) => {
      state.searchQuery.pageNum = page
      state.searchQuery.pageSize = pageSize
      loadOrders()
    }

    const loadRecords = async (pageNum) => {
      state.loading = true
      if (pageNum) state.searchQuery.pageNum = pageNum
      const query = Object.assign({}, state.searchQuery, {
        pageNo: state.searchQuery.pageNum,
        pageSize: state.searchQuery.pageSize
        // queryStartTime: state.searchQuery.queryStartTime ? new Date(state.searchQuery.queryStartTime).getTime() : null,
        // queryEndTime: state.searchQuery.queryEndTime ? new Date(state.searchQuery.queryEndTime).getTime() : null
      })
      const res = await _order.getRdrNotifyList(query)
      console.log('res', res)
      if (res.data.succ) {
        state.records = res.data.data.list.map(item => {
          return Object.assign({}, item, {
            eventDateUtc: moment(item.eventDateUtc).format('YYYY-MM-DD HH:mm:ss'),
            transactionAmount: parseMoney(item.transactionAmount) + ' ' + item.transactionCurrency,
            reportedAmount: parseMoney(item.reportedAmount) + ' ' + item.reportedCurrency,
            rdrDate: moment(item.rdrDate).format('YYYY-MM-DD HH:mm:ss'),
            fee: item.fee != null ? parseMoney(item.fee) + ' ' + item.feeCurrency : ' '
            // transactionDate: moment(item.transactionDate).format('YYYY-MM-DD HH:mm:ss')
          })
        })
        console.log('state.records', state.records)
        state.total = res.data.data.total
      }
      state.loading = false
    }

    const init = () => {
      loadRecords()
    }

    init()

    return {
      updatePage,
      loadRecords,
      dateRangeError,
      dateOpts,
      handleDateChange,
      exportAlert,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#orderToday {
  .table-part {
    margin-top: 12px;
  }
}
.op-part {
  display: flex;
  justify-content: flex-end;
  margin: 12px;
}
.date-range-error {
  color: red;
}
</style>
